import { WorkflowComponentParamType } from '../../types';
import { SelectWorkflowComponent } from './selectcomponent';
import { SINGLE_OUTPUT_NAME } from './singleoutputcomponent';
export class SelectSameSchemaWorkflowComponent extends SelectWorkflowComponent {
    canProvideOutputSchemas() {
        return true;
    }
    _getOutputSchemas({ workflow, params, schemas, connection, componentName }) {
        const tableInputName = this.inputs.find((input) => input.type === WorkflowComponentParamType.InputTable)?.name; // we assume there is at least one table input, otherwise don't use this class
        const value = params[tableInputName];
        let tablename;
        if (Array.isArray(value)) {
            tablename = value[0];
        }
        else {
            tablename = value;
        }
        const columns = this._getSchemaForTablename(tablename, schemas, connection);
        if (columns == undefined) {
            return [];
        }
        const fqn = this._getDryRunOutputTableFqn(workflow, params, connection, componentName, SINGLE_OUTPUT_NAME);
        return [
            {
                fqn,
                schema: columns
            }
        ];
    }
}
